import { create } from "zustand";

type SettersType<T> = {
  set: (newState: Partial<T>) => void;
  reset: () => void;
};

export function createState<T = any>(initialState: T) {
  type StateReturn = T & SettersType<T>;
  return create<StateReturn>((setState) => {
    return {
      ...initialState,
      set: (newState) => setState(newState as any),
      reset: () => setState(initialState as any),
    };
  });
}
